/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2023-03-17 10:24:03
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-07-05 11:11:28
 */
import logo from '@/assets/logo.png'

import HeaderRight from '@/components/HeaderRight';

import { storageUserName } from '@/utils/enum';
import { DefaultFooter } from '@ant-design/pro-components';
import { styled } from '@umijs/max';
const ScDefaultFooter = styled(DefaultFooter)`
    position: ${(props) => props.path.indexOf('login') >= 0 ? 'absolute' : 'relative'};
    bottom: 0;
    width: 100%;
    background: transparent;
`


const Layout = (props) => {
    const { initialState } = props
    const defaultFooterDom = <ScDefaultFooter path={window.location.hash} copyright='2024 湘江树图' links={[{
        key: '湘网信备43010422665538850014号',
        title: '湘网信备43010422665538850014号',
    }]} />;
    return {
        title: '联盟链应用市场运管平台',
        logo: logo,
        layout: 'mix',
        prefixCls: 'market',
        siderWidth: 220,
        rightContentRender: window.location.pathname.indexOf('login') >= 0 ? false : HeaderRight,
        // menu: {
        //     request: getMenu
        // },
        footerRender: () => defaultFooterDom,
        token: {
            bgLayout: '#fff',
            header: {
                heightLayoutHeader: 60,
                colorBgHeader: '#174FF2',
                colorHeaderTitle: '#fff',
            },

        },
    };
};
export default Layout;